import * as React from 'react';
import styled from 'styled-components';
import { StyledInformationalPage } from '../../../common/static.styles';
import { HeadTitle } from '../../../components/head-title/HeadTitle';
import { DefaultLayout } from '../../../layout/default/DefaultLayout';

/* tslint:disable:max-line-length */
const html = `
  <article id='node-89311' class='node node-plain clearfix' about='/content/sourced-traffic-disclosure' typeof='sioc:Item foaf:Document'>
    <header>
      <span property='dc:title' content='Sourced Traffic Disclosure' class='rdf-meta element-hidden'></span><span property='sioc:num_replies' content='0' datatype='xsd:integer' class='rdf-meta element-hidden'></span>
    </header>
    <div class='field field-name-body field-type-text-with-summary field-label-hidden'>
      <div class='field-items'>
        <div class='field-item even' property='content:encoded'>
          <h1> Sourced Traffic Disclosure</h1>
          <table border='2' cellpadding='5' cellspacing='0'>
            <tbody>
              <tr>
                <td >
                  <p><strong>Quarter</strong></p>
                </td>
                <td >
                  <p><strong>Percentage</strong></p>
                </td>
              </tr>
              <tr>
                <td >
                  <p>Q3, 2017</p>
                </td>
                <td >
                  <p>2.1%</p>
                </td>
              </tr>
              <tr>
                <td >
                  <p>Q4, 2017</p>
                </td>
                <td >
                  <p>2.4%</p>
                </td>
              </tr>
              <tr>
                <td >
                  <p>Q1, 2018</p>
                </td>
                <td >
                  <p>0.1%</p>
                </td>
              </tr>
              <tr>
                <td >
                  <p>Q2, 2018</p>
                </td>
                <td >
                  <p>0.0%</p>
                </td>
              </tr>
              <tr>
                <td >
                  <p>Q3, 2018</p>
                </td>
                <td >
                  <p>0.1%</p>
                </td>
              </tr>
              <tr>
                <td >
                  <p>Q4, 2018</p>
                </td>
                <td >
                  <p>0.1%</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>Q1, 2019</p>
                </td>
                <td>
                  <p>0.0%</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>Q2, 2019</p>
                </td>
                <td>
                  <p>0.0%</p>
                </td>
              </tr>
            </tbody>
          </table>
          <p>&nbsp;</p>
          <p><strong>Notes:</strong></p>
          <ul>
            <li>This chart discloses the percentage of visits acquired through paid sources.</li>
            <li>A visit is considered “acquired through paid sources” if the first page view is from a paid source.</li>
            <li>A visit is determined to be from a paid source based only on attributes collected during that visit.</li>
            <li>All sourced traffic is monitored in compliance with industry best practices as outlined in the MRC
            Invalid Traffic and Detection Guidelines.</li>
          </ul>
          <p>&nbsp;</p>
        </div>
      </div>
    </div>
    <footer>
    </footer>
  </article>
`;

// TODO: Add SEO props
const seo = {
  description: '',
};

const SourcedTrafficDisclosure = styled.div`
  p {
    margin: 0;
  }
  td {
    text-align: center;
  }
  ul {
    list-style: disc;
    margin-left: 20px;
  }
`;

// noinspection JSUnusedGlobalSymbols
export default () => (
  <DefaultLayout locale='en-US' seo={seo}>
    <HeadTitle title='Sourced Traffic Disclosure' />
    <StyledInformationalPage>
      <SourcedTrafficDisclosure>
        <div className='content' dangerouslySetInnerHTML={{ __html: html }} />
      </SourcedTrafficDisclosure>
    </StyledInformationalPage>
  </DefaultLayout>
);
